<template>
	<div>
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1">当前位置：</div>
				<!-- 课程管理
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1">开展信息化系统培训 咸宁市咸安区为液化气从业人员“充电”提能</div>
				<el-image :src="require('@/static/icon55.png')"></el-image> -->
				<div class="t2">报名人数</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回课程管理</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<div class="pageCon">
			<!-- 表格 -->
			<div class="biaoge animate__animated animate__fadeIn" data-wow-duration="0.8s">
				<div class="table">
					<div class="th f-ct">
						<p class="t1">序号</p>
						<p class="t2">课题名称</p>
						<p class="t3">讲师名称</p>
						<p class="t3">学习资料</p>
						<p class="t3">模拟考试</p>
						<p class="t3">视频学习</p>
					</div>
					<div class="td f-ct" v-for="(item,index) in 10">
						<p class="t1">{{index+1}}</p>
						<p class="t2">开展信息化系统培训 咸宁市咸安区为液化气从业人员“充电”提能</p>
						<p class="t3">张欣德</p>
						<div class="t4 f-ct">
							<el-image :src="require('@/static/icon74.png')"></el-image>
							<span>下载</span>
						</div>
						<p class="t4" @click="link('/classTest')">进入</p>
						<p class="t4" @click="link('/classVideo')">进入</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 弹出框 -->
		<div class="maskBg" @click="hbDown=false" v-if="hbDown"></div>
		<div class="subTips" v-if="hbDown">
			<div class="hbTit f-bct">
				<p>下载资料</p>
				<el-image @click="hbDown=false" class="cha" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="Tab">
				<div class="th f-ct">
					<p class="t3">资料名称</p>
					<p class="t4">文件大小</p>
					<p class="t5">下载</p>
				</div>
				<div class="tdBox">
					<div class="td f-ct" v-for="(item,index) in 8">
						<div class="t3">山河建设集团有限公司海南分公司</div>
						<div class="t4">500.50KB</div>
						<div class="t5 f-ct">
							<el-image :src="require('@/static/icon74.png')"></el-image>
							<span>下载</span>
						</div>
					</div>
				</div>
			</div>
			<div class="hbbtnBox f-ct">
				<div class="b1">返回</div>
			</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { login } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			hbDown:true,
			
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				}, 
				{
					value: '选项2',
					label: '双皮奶'
				}, 
				{
					value: '选项3',
					label: '蚵仔煎'
				}, 
				{
					value: '选项4',
					label: '龙须面'
				}, 
				{
					value: '选项5',
					label: '北京烤鸭'
				}
			],
			value: '',
		}
	},
	mounted() {
		
	},
	methods:{
		
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>

.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.pageCon{
	margin: 0 40px;
	padding: 24px;
	background: #fff;
	border-radius: 20px;
}
.biaoge{
	// padding: 24px;
	// padding-top: 0;
	// background: #fff;
	// margin: 0 40px;
	.table{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 879px;
				padding-left: 14px;
				text-align: left;
			}
			.t3{
				width: 140px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>p{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				&:last-child{
					border-right: 0;
				}
			}
			>div{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				justify-content: center;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 879px;
				text-align: left;
			}
			.t3{
				width: 141px;
			}
			.t4{
				width: 141px;
				color: #3B6492;
				cursor: pointer;
				.el-image{
					width: 18px;
					height: 18px;
				}
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}

.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	// width: 742px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 100%;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.Tab{
		margin: 0 15px;
		margin-top: 20px;
		margin-bottom: 22px;
		border: 1px solid #EBEEF5;
		.th{
			height: 51px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 51px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBF0FC;
				font-weight: bold;
				&:last-child{
					border: none;
				}
			}
			.t3{
				width: 507px;
				text-align: left;
				padding-left: 24px;
			}
			.t4{
				width: 113px;
			}
			.t5{
				width: 100px;
			}
		}
		.tdBox{
			height: 250px;
			overflow-y: scroll;
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				word-wrap:break-word;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 16px 8px;
				&:last-child{
					border: none;
				}
			}
			.t3{
				width: 507px;
				text-align: left;
				justify-content: flex-start;
				padding-left: 24px;
			}
			.t4{
				width: 113px;
			}
			.t5{
				width: 100px;
				.el-image{
					width: 20px;
					height: 20px;
					margin-right: 4px;
				}
				span{
					font-size: 14px;
					color: #3B6492;
				}
			}
		}
	}
	.hbbtnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>